<template lang="pug">
v-app
  section
    header.d-flex.row.flex-row.align-items-stretch.mb-5
      .col
        .row.flex-row.h-100
          .col-12
            router-link.button-previous.mr-2(to="/consultor-observaciones-calidad")
              i.fas.fa-chevron-left
            h1.m-0.font-italic.d-inline-block.align-middle
              | Pauta evaluación 
              span.text-nowrap.ad_text-secondary {{ type == 'SDA' || type == 'SDB'? 'SD': type}}
              | &nbsp;de&nbsp;
              span.ad_text-secondary {{ collab.name }}
              div(v-if="type == 'SDA' || type == 'SDB' || type == 'CP'")
                | &nbsp;realizada a&nbsp;
            div(v-if="type == 'SDA' || type == 'SDB' || type == 'CP'")                 
              .col.px-0.ad_select
                select(v-model='selectedCollab')
                  option(:value="null" disabled) Selecciona colaborador
                  option(:value="co._id", v-for="co in collab.collabs", :key="co._id") {{co.name}}
          .col.d-flex.align-self-end
            .h2
              | Ejecución
          
      .col-auto.text-right
        h1.m-0.font-italic
          small {{ moment().format("W") }}
        .row.d-flex.justify-content-end
          .col-auto
            .h4.d-flex.justify-content-between
              span.font-weight-bold.mr-3 Fecha de ejecución:
              em {{ moment().format("DD/MM/YYYY") }}
            .h4.d-flex.justify-content-between
              span.font-weight-bold.mr-3 Usuario ejecutor:
              em {{user.name}}

    section
      .d-flex.row.flex-row.flex-row-reverse.align-items-start.mt-4

        .col-auto
          .ad_border1-secondary.rounded-lg.overflow-hidden
            table.table.w-100.m-0.text-center
              thead
                tr
                  th Escala
                  th Nivel de ejecución
              tbody
                tr
                  td.text-center N/A
                  td No aplica
                tr
                  td.text-center 0
                  td No realizado
                tr
                  td.text-center 1
                  td Medianamente realizado
                tr
                  td.text-center 2
                  td Completamente realizado
        .col
          .card.p-0.ad_border2-primaryLight.rounded-xl
            .card-body
              .row
                .col-2
                  .h4.mb-3.ad_text-primary
                    | Pregunta
                .col
                  .h4.mb-3.ad_text-primary
                    | ¿Qué quieres lograr con tu equipo en este <em>{{ $route.params.type }}</em>?
                .col-auto
              .ad_bg-gray.rounded-lg.py-4
                .row.mx-0.py-2.border-bottom.align-items-center(v-for="(question, n) in question_score")
                  .col-2
                    p.m-0
                    strong {{ question.stage }}
                  .col.border-left.border-right
                    ul
                      li
                        p.mb-1 {{ question.evaluation }}
                  .col-auto.d-flex.flex-nowrap
                    input.consultor-evaluacion(type='radio', :name="question._id", :id="'option-1-' + n", :value="null", v-model="question_score[n].score")
                    label(:for="'option-1-' + n") 
                      small N/A
                    
                    input.consultor-evaluacion(type='radio', :name="question._id", :id="'option-2-' + n", :value='0', v-model="question_score[n].score")
                    label(:for="'option-2-' + n") 0

                    input.consultor-evaluacion(type='radio', :name="question._id", :id="'option-3-' + n", :value="1", v-model="question_score[n].score")
                    label(:for="'option-3-' + n") 1

                    input.consultor-evaluacion(type='radio', :name="question._id", :id="'option-4-' + n", :value="2", v-model="question_score[n].score")
                    label(:for="'option-4-' + n") 2


        section
      header.d-flex.row.flex-row.align-items-stretch.mb-5
        .col
          .row.flex-row.h-100 
            .col.d-flex.align-self-end
              .h2
                | Resultados Calidades

    section
        
      div.row
        div.col-sm(v-for="(evaluation) in evaluations")
          h3.text-center.mt-2.font-weight-bold
            | Semana {{evaluation.week_number}}
      div.row
        div.col-sm(v-for="(evaluation) in evaluations")
          h1.text-center.mt-2.font-weight-bold
            | {{(typeof evaluation.evaluation != 'number') ? evaluation.evaluation: evaluation.evaluation.toFixed(2)}} %
    hr.my-4
    h3.ad_text-grayMedio.mb-3
      i Comentarios
    .col-12.mt-5
          .form-group.mt-4
            textarea.form-control(placeholder='Agregar comentario', rows='3', v-model='comment')
          //- .text-right
          //-   button.btn.btn-secondary.py-2.px-3.font-1em(@click="_addComment($event.target)")
          //-     | Agregar
              
    
    .col-12.mt-5
      .row.mb-3(v-for="(comment) in guidelinesComments.slice().reverse()")
            .col-4.pr-0
              p.font-weight-bold.m-0 {{comment.user.name}}
              small.d-block {{ moment(comment.creation_date).format("DD-MM-YYYY") }}
              small.d-block {{ moment(comment.creation_date).format("HH:mm") }} hrs.
            .col-8.pl-0
              .dialog-box
                p {{comment.text}}
    .d-flex.row.flex-row.mt-4
      .col-12.text-center
        button.btn.btn-primary.py-2.px-5(@click="_saveAnswer($event.target)")
          em Guardar

        button.btn.btn-primary.py-2.px-5(@click="_sendAnswer($event.target)")
          em Evaluar
    b-modal(:id='infoModal.id' :title='infoModal.title', modal-class='modal-popUp', centered, button-size='lg', footer-class="justify-content-between", ok-variant='primary', ok-title='Grabar', @ok="answerGuidelines")
      | {{ infoModal.content }}
      <template slot='modal-cancel'>
        span.d-block.pt-2
        span.px-3
          | Cancelar
        span.d-block.pb-2
      </template>

                      
</template>

<script>
import moment from 'moment'
import { mapActions } from 'vuex';

export default {
  name: 'PautaAvance',

  data () {
    return {
      user: {},
      collab: { name: '' },
      guidelines: [],
      answers: [],
      evaluations: [],
      guidelineanswered: [],
      guidelinesComments: [],
      question_score: [],
      quest: null,
      selectedCollab: null,
      type: null,
      total: 0,
      comment: '',
      infoModal: {
        id: 'info-modal',
        title: '¡Atención!',
        content: ''
      }
    }
  },
  methods: {
    moment,
    ...mapActions('user', [
      'getUserById'
    ]),
    ...mapActions('consultant', [
      'getEvaluationQuestions',
      'answerGuideline',
      'getLastWeekHistory',
      'getAnsweredEvaluation'
    ]),
    ...mapActions('guidelinecomment', [
      'commentsByType',
      'addComment'
    ]),
    _calculateScore() {
      return new Promise((resolve, reject) => {
        try {
          const vm = this
          let allSelects = document.getElementsByClassName('consultor-evaluacion')
          let partial = 0
          let accepted = 0
          for (var i=0; i<allSelects.length; i++) {        
           if (allSelects[i].checked) {
              if (allSelects[i].value) {
                partial += Number(allSelects[i].value)
                accepted += 1
              }
              let isnew = true
              if (vm.answers.length > 0) {
                for (let indice in vm.answers) {
                  if (vm.answers[indice]._id == allSelects[i].name) {                           
                    vm.answers[indice].score = allSelects[i].value
                    isnew = false
                  }
                }
              }
              if (isnew) {
                vm.answers.push({_id: allSelects[i].name, score: allSelects[i].value})
              }
            }
          }

          vm.total = (partial * 100) / (accepted * 2)
          if (isNaN(vm.total)) {
            reject('debe marcar alguna opcion.')
          } else {
            resolve()
          }          
        } catch (e) {
          reject(e)
        }
      })
    },
    _sendAnswer(button) {
      const vm = this
      if (vm._canSend(vm.type)) {
        vm._calculateScore().then(() => {
          vm.$root.$emit('bv::show::modal', vm.infoModal.id, button)
          const modal = vm.$el.querySelector('.modal')
          // modal.style.left = '25%'
          // modal.style.right = '25%'
          // modal.style.top = '25%'
          // modal.style.height = '240px'
          vm.infoModal.content = `¿Está seguro de grabar pauta con ${vm.total.toFixed(2)}% de puntaje?`
        }, (error) => {
          let etoshow = (typeof error === 'string' || error instanceof String) ? error : 'Ha habido un error'
          vm.$notify({
            type: 'danger',
            title: 'Notificación',
            content: etoshow,
            closeable: true,
            duration: 5000
          })
        })
      } else {
        vm.$notify({
          type: 'danger',
          title: 'Notificación',
          content: 'Debe seleccionar un usuario',
          closeable: true,
          duration: 5000
        })
      }        
    },
    _saveAnswer() {
      const vm = this;
      vm._calculateScore().then(() => {     
        const type = vm.$route.params.type
        const week_number = moment().format("W")      
        const data = {
          consultant_user: vm.$store.state.auth.user.id,
          user_evaluated: vm.collab._id,
          collab_involve: vm.selectedCollab,        
          body: {
            questions: vm.answers,
            comment: vm.comment,
            week_number,
            type,
            order: 0
          }
        }
        if (vm._canSend(type)) {
          const loading = vm.$toast.loading('Enviando evaluación...')
          vm.answerGuideline(data).then(response => {
            if (response) {
              let data = {
                comment : vm.comment,
                type    : vm.type,
                user_id : vm.$store.state.auth.user.id,
                user_evaluated: vm.$route.params.collab
              }            
              vm.addComment(data).then(response => {
                if (response) {
                  vm.$notify({
                    type: 'success',
                    title: 'Notificación',
                    content: "Evaluacion guardada",
                    closeable: true,
                    duration: 5000
                  })
                  vm.guidelinesComments.push({
                    creation_date: moment(),
                    user: vm.$store.state.auth.user,
                    text: vm.comment
                  })
                  loading.hide()
                  vm.$router.push({ path: '/consultor-observaciones-calidad' })
                } else {
                  loading.hide()
                  vm.$notify({
                    type: 'danger',
                    title: 'Notificación',
                    content: 'Ha habido un error',
                    closeable: true,
                    duration: 5000
                  })
                }
              })                        
            } else {
              vm.$notify({
                type: 'danger',
                title: 'Notificación',
                content: 'Ha habido un error',
                closeable: true,
                duration: 5000
              })
            }
          })        
        } else {
          vm.$notify({
            type: 'danger',
            title: 'Notificación',
            content: 'Debe seleccionar un usuario',
            closeable: true,
            duration: 5000
          })
        }
      }, (error) => {
        let etoshow = (typeof error === 'string' || error instanceof String) ? error : 'Ha habido un error'
        vm.$notify({
          type: 'danger',
          title: 'Notificación',
          content: etoshow,
          closeable: true,
          duration: 5000
        })
      })
    },
    answerGuidelines() {
      const vm = this;      
      const type = vm.$route.params.type
      const week_number = moment().format("W")      
      const loading = vm.$toast.loading('Enviando evaluación...')
      if (vm._canSend(type)) {
        let data = {
          comment : vm.comment,
          type    : vm.type,
          user_id : vm.$store.state.auth.user.id,
          user_evaluated: vm.$route.params.collab
        }            
        vm.addComment(data).then(response => {
          if (response) {
            vm.guidelinesComments.push({
              creation_date: moment(),
              user: vm.$store.state.auth.user,
              text: vm.comment
            })
            const data = {
              consultant_user: vm.$store.state.auth.user.id,
              user_evaluated: vm.collab._id,
              collab_involve: vm.selectedCollab,        
              body: {
                questions: vm.answers,
                comment: vm.guidelinesComments.slice().reverse(),
                week_number,
                type,
                order: 2
              }
            }
            vm.answerGuideline(data).then(response => {
              vm.$notify({
                type: 'success',
                title: 'Notificación',
                content: "Evaluacion creada",
                closeable: true,
                duration: 5000
              })                
              loading.hide()
              vm.$router.push({ path: '/consultor-observaciones-calidad' })
            }, (error) => {
              loading.hide()
              vm.$notify({
                type: 'danger',
                title: 'Notificación',
                content: error,
                closeable: true,
                duration: 5000
              })
            })  
          } else {
            loading.hide()
            vm.$notify({
              type: 'danger',
              title: 'Notificación',
              content: 'La carga de comentario falló',
              closeable: true,
              duration: 5000
            })
          }
        })              
      } else {
        vm.$notify({
          type: 'danger',
          title: 'Notificación',
          content: 'Debe seleccionar un usuario',
          closeable: true,
          duration: 5000
        })
      }
    },
    _canSend(type) {
      const vm = this
      let send = true
      if (type == 'SDA' || type == 'SDB' || type == 'CP') {
        send = vm.selectedCollab ? true : false
      }
      return send
    },
    _addComment(button) {
      const vm = this
      const loading = vm.$toast.loading('Agregando Comentario...')
      let data = {
        comment : vm.comment,
        type    : vm.type,
        user_id : vm.$store.state.auth.user.id,
        user_evaluated: vm.$route.params.id
      }
      vm.addComment(data).then(response => {
        if (response) {
          vm.$notify({
            type: 'success',
            title: 'Notificación',
            content: "Comentario creado",
            closeable: true,
            duration: 5000
          })
          vm.guidelinesComments.push({
            creation_date: moment(),
            user: vm.$store.state.auth.user,
            text: vm.comment
          })
        } else {
          vm.$notify({
            type: 'danger',
            title: 'Notificación',
            content: 'Ha habido un error',
            closeable: true,
            duration: 5000
          })
        }
      })
      loading.hide()
        
    },
    _prepareQuestions() {
      return new Promise((resolve, reject) => {
        const vm = this;
        vm.getEvaluationQuestions(vm.type).then(() => {        
          vm.guidelines = vm.$store.getters['consultant/getGuidelines']
            if (vm.guidelines.length > 0) {
              for (let indexg in vm.guidelines) {
                vm.question_score.push({
                  _id: vm.guidelines[indexg]._id,
                  score: -1,
                  stage: vm.guidelines[indexg].stage,
                  evaluation: vm.guidelines[indexg].evaluation
                })
              }
              resolve()
            } else {
              reject('No se encontaron las preguntas')
            }
        }, (error) => {
          reject(error)
        })
      })      
    }
  },
  mounted() {
    const vm = this;
    const { id } = vm.$store.state.auth.user
    vm.user = vm.$store.getters['auth/getUserInfo']
    vm.type = vm.$route.params.type
    const loading = vm.$toast.loading('Cargando...')
    vm.getUserById(vm.$route.params.collab).then(response => {
      vm.collab = response
    })
    const data = {
        id: vm.$route.params.id,
        type: vm.type
    }
    vm.getAnsweredEvaluation(data).then(() => {
      vm.guidelineanswered = vm.$store.getters['consultant/getAnsweredEvaluation']
      if (vm.guidelineanswered) {        
        vm.selectedCollab = vm.guidelineanswered[vm.type].collab_involve
        vm._prepareQuestions().then(() => {
          for (let q of vm.guidelineanswered[vm.type].questions) {
            for (let index in vm.question_score) {
              if (q._id == vm.question_score[index]._id) {
                vm.question_score[index].score = q.score
              }
            }
          }
        }, (error) => {
          vm.$notify({
            type: 'danger',
            title: 'Notificación',
            content: error,
            closeable: true,
            duration: 5000
          })  
        })
      } else {
        vm.$notify({
          type: 'danger',
          title: 'Notificación',
          content: 'No se ha podido encontrar la pauta.',
          closeable: true,
          duration: 5000
        })
      }
      let history_data = {
        user_id: vm.$route.params.collab ,
        type : vm.type
      }
      vm.getLastWeekHistory(history_data).then(response => {
        vm.evaluations = response.evaluations;
      })

      let queryComments = {
        user_evaluated: vm.$route.params.collab,
        type : vm.type
      }
      vm.commentsByType(queryComments).then(response => {
        if (response.guidelinesComments.hasOwnProperty(vm.type)) {
          vm.guidelinesComments = response.guidelinesComments[vm.type];
        }
      })
      loading.hide()
    }, (error) => {
      vm.$notify({
        type: 'danger',
        title: 'Notificación',
        content: error,
        closeable: true,
        duration: 5000
      })
    })
  }
}
</script>




// WEBPACK FOOTER //
// src/views/consultor-pauta-avance.vue